import { Range } from 'rc-slider';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { Input } from '../Common/Input';

export interface PriceRangeProps {
    values: PriceRangeValues;
    currencyCode: string;
    onChange: (priceValues: number[]) => void;
    onMinChange: (value: string) => void;
    onMaxChange: (value: string) => void;
    onAfterChange: () => void;
}

export interface PriceRangeValues {
    selected: number[];
    thresholds: number[];
    slider: number[];
    input: string[];
}

interface PriceRangeState {
    minValue: string;
    maxValue: string;
}

export class PriceRange extends React.Component<PriceRangeProps, PriceRangeState> {
    constructor(props: PriceRangeProps) {
        super(props);

        this.state = {
            minValue: props.values.input[0],
            maxValue: props.values.input[1]
        };
    }

    componentDidUpdate(prevProps: Readonly<PriceRangeProps>) {
        if (prevProps.values.input[0] != this.props.values.input[0] || prevProps.values.input[1] != this.props.values.input[1]) {
            this.setState({
                minValue: this.props.values.input[0],
                maxValue: this.props.values.input[1]
            });
        }
    }

    render() {
        return (
            <div className="PriceRange">
                <div className="PriceRange__Slider">
                    <Range
                        min={this.props.values.thresholds[0]}
                        max={this.props.values.thresholds[1]}
                        onAfterChange={() => this.props.onAfterChange()}
                        onChange={(values) => this.props.onChange(values)}
                        value={this.props.values.slider}
                    />
                </div>
                <div className="PriceRange__Content">
                    <div className="PriceRange__Input">
                        <label htmlFor="PriceMin">{getTranslation(keys['priceRange.from'])}:</label>
                        <div className="PriceRange__Value">
                            <Input
                                type="text"
                                value={this.formatPrice(this.state.minValue)}
                                id="PriceMin"
                                interval={1000}
                                onFocus={(e) => e.target.select()}
                                onChange={(value) => this.setState({ minValue: this.getValue(value) })}
                                onAfterChange={() => {
                                    this.props.onMinChange(this.state.minValue);
                                }}
                            />
                            <span>{this.props.currencyCode}</span>
                        </div>
                    </div>
                    <div className="PriceRange__Input">
                        <label htmlFor="PriceMax">{getTranslation(keys['priceRange.to'])}:</label>
                        <div className="PriceRange__Value">
                            <Input
                                type="text"
                                value={this.formatPrice(this.state.maxValue)}
                                id="PriceMax"
                                interval={1000}
                                onFocus={(e) => e.target.select()}
                                onChange={(value) => this.setState({ maxValue: this.getValue(value) })}
                                onAfterChange={() => {
                                    this.props.onMaxChange(this.state.maxValue);
                                }}
                            />
                            <span>{this.props.currencyCode}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private getValue = (value: string) => {
        return value.replace(/[^0-9.]/g, '');
    };

    private formatPrice = (price: string) => {
        return Math.ceil(parseFloat(price));
    };
}
